export default __webpack_public_path__ + "static/media/CTA_Arrow.a801582c.svg";